module.exports = __webpack_public_path__ + "img/sgd.1ab361bc.svg";